
// Color utility functions for parcel types
export const getGradientClasses = (colorFrom: string, colorTo: string): string => {
  // Map database color values to actual Tailwind gradient classes
  const gradientMap: Record<string, string> = {
    // Blue gradients
    'from-blue-500_to-blue-600': 'from-blue-500 to-blue-600',
    // Green gradients  
    'from-green-500_to-green-600': 'from-green-500 to-green-600',
    // Orange gradients
    'from-orange-500_to-orange-600': 'from-orange-500 to-orange-600',
    // Red gradients
    'from-red-500_to-red-600': 'from-red-500 to-red-600',
    // Purple gradients
    'from-purple-500_to-purple-600': 'from-purple-500 to-purple-600',
    // Indigo gradients
    'from-indigo-500_to-indigo-600': 'from-indigo-500 to-indigo-600',
    // Additional color combinations
    'from-teal-500_to-teal-600': 'from-teal-500 to-teal-600',
    'from-pink-500_to-pink-600': 'from-pink-500 to-pink-600',
    'from-yellow-500_to-yellow-600': 'from-yellow-500 to-yellow-600',
    'from-cyan-500_to-cyan-600': 'from-cyan-500 to-cyan-600',
  };

  // Create key from color values
  const key = `${colorFrom}_${colorTo}`;
  
  // Return mapped gradient or fallback to blue
  return gradientMap[key] || 'from-blue-500 to-blue-600';
};

export const getIconGradientClasses = (colorFrom: string, colorTo: string): string => {
  return getGradientClasses(colorFrom, colorTo);
};

// Get available gradient options for admin interface
export const getAvailableGradients = () => [
  { from: 'from-blue-500', to: 'to-blue-600', label: 'Blue', preview: 'from-blue-500 to-blue-600' },
  { from: 'from-green-500', to: 'to-green-600', label: 'Green', preview: 'from-green-500 to-green-600' },
  { from: 'from-orange-500', to: 'to-orange-600', label: 'Orange', preview: 'from-orange-500 to-orange-600' },
  { from: 'from-red-500', to: 'to-red-600', label: 'Red', preview: 'from-red-500 to-red-600' },
  { from: 'from-purple-500', to: 'to-purple-600', label: 'Purple', preview: 'from-purple-500 to-purple-600' },
  { from: 'from-indigo-500', to: 'to-indigo-600', label: 'Indigo', preview: 'from-indigo-500 to-indigo-600' },
  { from: 'from-teal-500', to: 'to-teal-600', label: 'Teal', preview: 'from-teal-500 to-teal-600' },
  { from: 'from-pink-500', to: 'to-pink-600', label: 'Pink', preview: 'from-pink-500 to-pink-600' },
  { from: 'from-yellow-500', to: 'to-yellow-600', label: 'Yellow', preview: 'from-yellow-500 to-yellow-600' },
  { from: 'from-cyan-500', to: 'to-cyan-600', label: 'Cyan', preview: 'from-cyan-500 to-cyan-600' },
];
